
const base_url = process.env.NEXT_PUBLIC_BASE_URL

export const SOFT_DRINKS_API = `${base_url}/api/drinks/non-alcoholic`
export const ALCOHOLIC_DRINKS_API = `${base_url}/api/drinks/alcoholic`